import AvatarUpload from 'components/common/AvatarUpload';
import React, { useState } from 'react';
import { Button, Card, Col, Modal, Row } from 'react-bootstrap';
import team15 from 'assets/img/team/avatar.webp';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import { currencyFormat, PF } from 'helpers/utils';
import TimeAgo from 'timeago-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSpinner, faXmark } from '@fortawesome/free-solid-svg-icons';
import EditVendor from './EditVendor';
import { useQuery } from '@tanstack/react-query';
import { getVendorById, VendorProfileUpdate } from 'api/user/vendor_requests';

const EcomVendorCard = () => {
  const vendorDetails = useSelector((state: RootState) => state.user?.vendor);
  const { user } = useSelector((state: RootState) => state?.auth);

  const [showMOdal, setShowModal] = useState(false);

  const { data: vendor, isLoading } = useQuery<VendorProfileUpdate>({
    queryKey: ['single-vendor'],
    queryFn: () => getVendorById()
  });

  if (isLoading)
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <FontAwesomeIcon
          icon={faSpinner}
          spin
          size="2x"
          className="text-primary"
        />
      </div>
    ); // or show loader

  return (
    <div>
      <Card className="h-100">
        <Card.Body>
          <div className="border-bottom border-dashed pb-4">
            <Row className="align-items-center g-3 g-sm-5 text-center text-sm-start">
              <Col xs={12} sm="auto">
                <AvatarUpload
                  size="5xl"
                  src={
                    user?.avatar && user.avatar !== ''
                      ? PF + user?.avatar
                      : team15
                  }
                />
              </Col>

              <Col xs={12} sm="auto" className="flex-1">
                <h3>{vendorDetails.fullName}</h3>
                <p className="text-body-secondary">
                  Joined{' '}
                  {vendorDetails.createdAt ? (
                    <TimeAgo datetime={vendorDetails.createdAt} />
                  ) : (
                    ''
                  )}
                </p>
              </Col>
              <Col xs={12} sm="auto">
                <Button onClick={() => setShowModal(true)}>
                  <FontAwesomeIcon className="me-2" icon={faEdit} />
                  Edit Profile
                </Button>{' '}
              </Col>
            </Row>
          </div>
          <div className="d-flex flex-between-center pt-4">
            <div>
              <h6 className="mb-2 text-body-secondary">Total Revenue</h6>
              <h4 className="fs-7 text-body-highlight mb-0">
                {currencyFormat(vendorDetails.totalRevenue, {
                  style: 'currency',
                  currency: 'SAR'
                })}
              </h4>
            </div>
            <div className="text-end">
              <h6 className="mb-2 text-body-secondary">Last Order</h6>
              <h4 className="fs-7 text-body-highlight mb-0">
                {vendorDetails.lastOrderDate ? (
                  <TimeAgo datetime={vendorDetails.lastOrderDate} />
                ) : (
                  ''
                )}
              </h4>
            </div>
            <div className="text-end">
              <h6 className="mb-2 text-body-secondary">Total Orders</h6>
              <h4 className="fs-7 text-body-highlight mb-0">
                {vendorDetails.totalOrders}
              </h4>
            </div>
          </div>
        </Card.Body>
      </Card>
      <Modal
        show={showMOdal}
        onHide={() => setShowModal(false)}
        centered
        size="xl"
      >
        <Card className="shadow-lg border-0 rounded-4">
          <Card.Header className="fw-semibold fs-6 py-3 rounded-top-4 d-flex justify-content-between align-items-center">
            <h4 className="mb-0">Edit Vendor Profile</h4>
            <Button
              variant="link"
              className="p-0 border-0 text-danger"
              onClick={() => setShowModal(false)}
              aria-label="Close"
            >
              <FontAwesomeIcon className="me-2" icon={faXmark} />
            </Button>
          </Card.Header>
          <Card.Body className="bg-light-subtle py-4">
            <EditVendor
              setShowModal={setShowModal}
              showMOdal={showMOdal}
              vendor={vendor}
            />
          </Card.Body>
        </Card>
      </Modal>
    </div>
  );
};

export default EcomVendorCard;
